'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _OverlayTrigger = require('react-bootstrap/lib/OverlayTrigger');

var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);

var _Popover = require('react-bootstrap/lib/Popover');

var _Popover2 = _interopRequireDefault(_Popover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var ConfirmDeletePopover = (0, _classAutobindDecorator2.default)(_class = (_temp = _class2 = function (_Component) {
  _inherits(ConfirmDeletePopover, _Component);

  function ConfirmDeletePopover() {
    _classCallCheck(this, ConfirmDeletePopover);

    return _possibleConstructorReturn(this, (ConfirmDeletePopover.__proto__ || Object.getPrototypeOf(ConfirmDeletePopover)).apply(this, arguments));
  }

  _createClass(ConfirmDeletePopover, [{
    key: 'setRefOverlay',
    value: function setRefOverlay(ref) {
      this.refOverlay = ref;
    }
  }, {
    key: 'setRefPopover',
    value: function setRefPopover(ref) {
      this.refPopover = ref;
    }
  }, {
    key: 'onClickDelete',
    value: function onClickDelete() {
      this.props.onDelete(this.props.data);
      this.refOverlay.hide();
    }
  }, {
    key: 'onClickCancel',
    value: function onClickCancel() {
      this.refOverlay.hide();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_OverlayTrigger2.default, _extends({}, this.props, { overlay: this.popoverComponent, ref: this.setRefOverlay }));
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'popoverComponent',
    get: function get() {
      var name = this.props.name;

      return _react2.default.createElement(
        _Popover2.default,
        { id: 'popover-confirmdelete-' + name, className: 'popover-confirmdelete', ref: this.setRefPopover },
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement(
            'p',
            null,
            'Delete this ' + name + '?'
          ),
          _react2.default.createElement(
            _Button2.default,
            { bsStyle: 'primary', bsSize: 'xsmall', onClick: this.onClickDelete },
            'Delete'
          ),
          _react2.default.createElement(
            _Button2.default,
            { bsStyle: 'link', bsSize: 'xsmall', onClick: this.onClickCancel },
            'Cancel'
          )
        )
      );
    }
  }]);

  return ConfirmDeletePopover;
}(_react.Component), _class2.defaultProps = {
  onDelete: _noop3.default,
  placement: 'bottom',
  trigger: 'click'
}, _class2.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  name: _propTypes2.default.string,
  onDelete: _propTypes2.default.func.isRequired
}, _temp)) || _class;

var _default = ConfirmDeletePopover;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ConfirmDeletePopover, 'ConfirmDeletePopover', '/app/src/components/common-popovers/ConfirmDeletePopover.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common-popovers/ConfirmDeletePopover.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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